import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { ILicenseTierCount } from 'types/organization';
import { NORTHSPYRE_TIER_TYPES } from 'bricks/constants';

type LicenseTierCountMapped = Record<NORTHSPYRE_TIER_TYPES, number>;

const getActiveProjectsByLicenseTier = async (
    organizationId: string,
): Promise<ILicenseTierCount> => {
    const response = await axiosInstance.get<ILicenseTierCount>(
        API_ENDPOINTS.ORGANIZATION.PROJECTS_BY_LICENSE_TIER(organizationId),
        {
            params: {
                active: true,
            },
        },
    );
    return response.data;
};

const transformTierCounts = (
    tierCounts: ILicenseTierCount,
): LicenseTierCountMapped => ({
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_FOR_VENDORS]: tierCounts.northspyreForVendors,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN]: tierCounts.northspyrePlan,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PLAN_PLUS]: tierCounts.northspyrePlanPlus,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_PRO]: tierCounts.northspyrePro,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_ENTERPRISE]: tierCounts.northspyreEnterprise,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_HISTORICAL_DATA]: tierCounts.northspyreHistoricalData,
    [NORTHSPYRE_TIER_TYPES.NORTHSPYRE_LITE]: tierCounts.northspyreLite,
});

export const useGetActiveProjectsByLicenseTier = (
    organizationId: string,
    options?: Omit<
    UseQueryOptions<ILicenseTierCount, Error, LicenseTierCountMapped>,
    'queryKey' | 'queryFn'
  >,
) => useQuery<ILicenseTierCount, Error, LicenseTierCountMapped>({
    queryKey: [QUERY_KEYS.ORGANIZATION.PROJECTS_BY_LICENSE_TIER, organizationId],
    queryFn: () => getActiveProjectsByLicenseTier(organizationId),
    select: transformTierCounts,
    ...(options ?? {}),
});

export default useGetActiveProjectsByLicenseTier;
